import { MouseEvent, useRef } from 'react'
import { Box, Typography } from '@mui/material'
// helper
import { handleLink } from '$logic/router/url'
import { showLinkMenu } from '$comp/modals/menus/link-menu'
import { getLinkText } from '$func/link'

const LINK_DIVISION_RATE = 2 / 3
export function OneLineLinkRenderer({ link: rawLink }: { link: string }) {
  const link = getLinkText(rawLink)
  const secondPartRef = useRef(null)
  const linkLength = link.length
  const position = Math.ceil(linkLength * LINK_DIVISION_RATE)
  const firstPart = link.substring(0, position)
  const secondPart = link.substring(position, linkLength)

  return (
    <Box
      sx={{
        cursor: 'pointer',
        height: '20px',
        overflow: 'hidden',
        whiteSpace: 'no-wrap',
        display: 'flex',
      }}
      onContextMenu={(e: MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
        showLinkMenu({ link })
      }}
      onClick={() => handleLink(link)}
    >
      <Typography
        variant="paragraph3"
        color="secondary"
        dir="ltr"
        sx={{
          display: 'inline-block',
          minWidth: 'fit-content',
          maxWidth: `${(1 - LINK_DIVISION_RATE) * 100}%`,
        }}
        ref={secondPartRef}
      >
        {secondPart}
      </Typography>
      <Typography
        variant="paragraph3"
        color="secondary"
        dir="ltr"
        noWrap
        maxWidth={`${LINK_DIVISION_RATE * 100}%`}
        sx={{ display: 'inline-block' }}
      >
        {firstPart}
      </Typography>
    </Box>
  )
}
